import React from 'react';
import PropTypes from 'prop-types';
import VerticalSpacer from '../../components_common/VerticalSpacer';
import HorizontalSpacer from '../../components_common/HorizontalSpacer';
import BrowseTilePairTitle from './styled/BrowseTilePairTitle';
import BrowseTilePairContainer from './styled/BrowseTilePairContainer';
import BrowseImageTile from './BrowseImageTile';

const BrowseTilePair = ({ title, leftImageTitle, leftImage, leftUrl, rightImageTitle, rightImage, rightUrl }) => (
  <div>
    <BrowseTilePairTitle>{title}</BrowseTilePairTitle>
    <VerticalSpacer height="5px" />
    <BrowseTilePairContainer>
      <BrowseImageTile title={leftImageTitle} image={leftImage} url={leftUrl} />
      <HorizontalSpacer width="10px" />
      <BrowseImageTile title={rightImageTitle} image={rightImage} url={rightUrl} />
    </BrowseTilePairContainer>
  </div>
);

BrowseTilePair.propTypes = {
  title: PropTypes.string.isRequired,
  leftImage: PropTypes.string.isRequired,
  leftUrl: PropTypes.string.isRequired,
  rightImage: PropTypes.string.isRequired,
  leftImageTitle: PropTypes.string.isRequired,
  rightImageTitle: PropTypes.string.isRequired,
  rightUrl: PropTypes.string.isRequired,
};

export default BrowseTilePair;
